/**
 * Karrier Smart Component Module
 * @author Erik Banhalmi 2017.06.27.
 */
import angular from 'angular';
import { CareerComponent } from './career.component';
import careerHandler from './../career-handler.module';

import universalQoutationDisplayer from './../../qoutation-displayer/universal-qoutation-displayer/universal-quatation-displayer.module';


export const careerModule = angular
	.module('career', [careerHandler, universalQoutationDisplayer])
	.component('career', CareerComponent)
	.name;
